import { commitMutation, graphql } from "react-relay";
import environment from "../Environment";
import { GC_USER_ID, GC_AUTH_TOKEN } from "../constants";

const mutation = graphql`
	mutation SigninMutation($email: String!, $password: String!) {
		tokenAuth(email: $email, password: $password) {
			token
			user {
				id
			}
		}
	}
`;


export default (email, password, callback) => {
	const variables = {
		email: email,
		password: password
	};

	commitMutation(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (response.tokenAuth) {
				const token = response.tokenAuth.token;
				const id = response.tokenAuth.user.id;
				callback(id, token);
			} else {
				callback(null, null);
			}
		},
		onError: err => console.error(err)
	});
};
